<template>
  <div class="flex flex-col gap-3">
    <div :class="['pug-upload', !fileList.length ? 'no-file' : '']">
      <el-upload
        ref="uploadImgRef"
        list-type="picture"
        class="upload-container"
        :action="action"
        :limit="limit"
        :accept="accept"
        :before-upload="beforeUpload"
        :on-remove="onRemove"
        :on-success="onSuccess"
        :on-preview="onPreview"
        :on-error="onError"
        :data-testid="dataTestid"
      >
        <div class="upload-area">
          <slot v-if="!fileList.length"></slot>
        </div>
        <div v-if="otherPreView" class="docx-area">
          <img src="@/assets/images/register/docx.png" alt="" srcset="" /><span>{{ otherPreViewSourceName }}</span>
        </div>
        <vue-pdf-embed
          v-else-if="pdfSource"
          ref="pdfRef"
          :source="pdfSource"
          :width="pdfPreviewWidth"
          :height="100"
          :page="1"
          @rendered="setPreviewImgPositionEvent"
        />
      </el-upload>

      <div class="actions">
        <div class="actions-item fullscreen-btn" data-testid="fullscreen" @click="handlePreViewFile">
          <i class="el-icon-zoom-in"></i>
        </div>

        <div class="actions-item delete-btn" v-if="isCustomerRemove" data-testid="deleteFile" @click="removeFile">
          <i class="el-icon-delete"></i>
        </div>
        <div class="actions-item delete-btn" v-else data-testid="deleteFile" @click="onRemove">
          <i class="el-icon-delete"></i>
        </div>
      </div>

      <ElImageViewer
        v-if="showPreViewImage && fileList.length > 0"
        :on-close="closeViewer"
        :z-index="3000"
        :url-list="fileList.map(item => item.url)"
        hide-on-click-modal
      />

      <div v-if="showPreViewPdf" class="pdf-previewer">
        <div class="close-preview-btn" @click="showPreViewPdf = false">
          <i class="el-icon-circle-close text-[#bdbcbd]"></i>
        </div>
        <div class="app-content">
          <vue-pdf-embed ref="pdfRef" :source="pdfSource" :page="page" @loaded="handleDocumentLoad" />
        </div>
        <div class="app-button">
          <el-button :disabled="page <= 1" @click="page--">❮</el-button>
          <span>{{ page }} / {{ pageCount }}</span>
          <el-button :disabled="page >= pageCount" @click="page++">❯</el-button>
        </div>
      </div>
    </div>
    <div slot="tip" class="el-upload__tip text-xs text-blackG4" v-if="showTip">
      {{ $t('fileUploader.supportedFormatCustom', { files: addTextSpacing(allowedFile) }) }}
      <br />
      {{ $t('fileUploader.maxSize', { maxSize: maxSize }) }}
      <br />
      {{ $t('fileUploader.maxFileNum', { maxFileNum: limit }) }}
    </div>
  </div>
</template>

<script>
import { allowTypes } from '@/util/urlToFile';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
// import confirmID from '@/mixins/register/vfscRegister/confirmID';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js';

export default {
  name: 'vUpload',
  components: {
    ElImageViewer,
    VuePdfEmbed
  },
  // mixins: [confirmID],
  props: {
    limit: Number,
    accept: {
      type: String,
      default: 'image/png, image/jpeg, image/jpg, image/bmp, .pdf, .doc, .docx'
    },
    maxSize: {
      type: Number,
      default: 5
    },
    allowedFile: {
      type: Array,
      default: function () {
        return ['png', 'jpg', 'jpeg', 'bmp', 'pdf', 'doc', 'docx'];
      }
    },
    dataTestid: {
      type: String
    },
    isCustomerRemove: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: '/api/file/upload'
    },
    showTip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      showPreViewImage: false,
      pdfSource: '',
      isCurrentFilePdf: false,
      isCurrentFileImage: false,
      showPreViewPdf: false,
      currentWidth: this.width,
      page: 1,
      pageCount: null,
      otherPreView: false,
      otherPreViewSourceName: ''
    };
  },
  watch: {
    fileList(val) {
      if (val.length === 0) {
        this.clearData();
      }
    }
  },
  computed: {
    pdfPreviewWidth() {
      let border = 1;
      return Math.floor(this.currentWidth - border * 2);
    }
  },
  methods: {
    clearFileList() {
      console.log('clearFileList');
      this.fileList = [];
      this.updateFileInfo();
    },
    clearData() {
      this.pdfSource = '';
      this.isCurrentFileImage = false;
      this.showPreViewImage = false;
      this.showPreViewPdf = false;
      this.page = 1;
      this.pageCount = null;
      this.otherPreView = false;
      this.isCurrentFilePdf = false;
      this.$refs.uploadImgRef.clearFiles();
    },
    handleDocumentLoad({ numPages }) {
      this.pageCount = numPages;
    },

    setPreviewImgPositionEvent() {
      this.$refs.pdfRef.$el.style = `display: inline-block;position: inherit;opacity:1; transition: 'all 0.3s';margin:0 auto;`;
    },
    handlePreViewFile() {
      if (this.isCurrentFilePdf) {
        this.showPreViewPdf = true;
      } else if (this.isCurrentFileImage) {
        this.showPreViewImage = true;
      } else {
        this.$message({ message: this.$t('fileUploader.errorPreview'), type: 'error' });
      }
    },
    getRef() {
      return this.$refs.uploadImgRef;
    },
    closeViewer() {
      this.showPreViewImage = false;
    },
    onPreview(file) {
      // Not uploaded
      if (!file || !file.response || !file.response.data) return;

      let html = '';
      let allow = Object.keys(allowTypes).includes(file.raw.type);
      if (allow) {
        html = `<${allowTypes[file.raw.type]} src="${file.response.data}" class='${allowTypes[file.raw.type]}Ref' />`;
        this.$confirm(html, '', {
          showCancelButton: false,
          showConfirmButton: false,
          dangerouslyUseHTMLString: true,
          center: true
        });
      } else {
        console.log('不支持预览');
        this.$message({ message: this.$t('fileUploader.errorPreview'), type: 'error' });
      }
    },
    updateFileInfo(file = '') {
      this.$emit('updateFileInfo', { fileList: this.fileList, file });
    },
    beforeUpload(file) {
      if (file.size / 1024 / 1024 > this.maxSize) {
        console.log('file size ' + file.size + ' is over size');
        this.$message({
          message: this.$t('fileUploader.maxSizeErrMsg', { maxSize: this.maxSize }),
          type: 'error'
        });
        return false;
      }
      if (!this.allowedFile.some(s => file.name.toLowerCase().endsWith(s))) {
        console.log('unsupported file type: ' + file.name);
        this.$message({ message: this.$t('fileUploader.failedFileExtension'), type: 'error' });
        return false;
      }
    },
    changeCurrentFileType(file) {
      const type = file.type || file.raw.type;
      if (type.endsWith('png') || type.endsWith('jpg') || type.endsWith('jpeg') || type.endsWith('bmp')) {
        this.isCurrentFileImage = true;
      } else if (type.endsWith('pdf')) {
        this.isCurrentFilePdf = true;
        this.pdfSource = file.url;
      } else this.otherPreView = true;
      this.otherPreViewSourceName = file.name;
    },
    onRemove(value) {
      if (!this.isCustomerRemove) {
        const file = this.$refs.uploadImgRef.uploadFiles[0];
        this.updateFileInfo(file);
        this.fileList = [];
        this.$refs.uploadImgRef.clearFiles();
      }
    },
    onSuccess(response, file) {
      console.log(response, file, 'filefile');
      switch (response.code) {
        case 0:
          this.fileList.push({ ...file, source: file.url, url: response.data });
          this.changeCurrentFileType(file);
          this.updateFileInfo();
          break;
        case 'session_timeout':
          return this.$router.push(response.loginUrl);
        case 500:
          return this.removeUnUploadFile(file);
      }
    },
    onError() {
      this.$message({ message: this.$t('responseMsg.500'), type: 'error' });
    },
    removeFile(file) {
      const uploadFiles = this.$refs['uploadImgRef'].uploadFiles;
      const index = uploadFiles.findIndex(data => data.response.data === file.response.data);
      uploadFiles.splice(index, 1);
      this.fileList.splice(index, 1);
      this.updateFileInfo();
    },
    removeUnUploadFile(file) {
      this.removeFile(file);
      this.$message({ message: this.$t('fileUploader.failedFileExtension'), type: 'error' });
    },
    addTextSpacing(value) {
      return Array.isArray(value) ? value.join(', ') : '';
    }
  }
};
</script>
<style lang="scss" scoped>
.pug-upload {
  position: relative;
  height: 100px;
  width: 48%;
  margin-right: 2%;
  .actions {
    opacity: 0;
    width: 100%;
    height: 100px;
    line-height: 100px;
    position: absolute;
    border-radius: 20px;
    left: 0;
    top: 0;
    text-align: center;
    color: #fff;
    font-size: 20px;
    background-color: rgba(0, 81, 255, 0.07);
    transition: opacity 0.3s;
    cursor: pointer;
    .actions-item {
      width: 20px;
      height: 20px;
      display: inline-block;
      color: #bdbcbd;
      &:first-child {
        margin-right: 15px;
      }
    }
    &:hover {
      opacity: 1;
    }
  }

  .upload-container {
    width: 100%;
    height: 100%;
    position: relative;
  }

  /deep/ .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #bdbcbd;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    .upload-area > div::before {
      content: '';
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url(~@/assets/images/register/upload1.png);
      background-size: 100% 100%;
      position: relative;
      top: 2px;
      right: 4px;
    }
    &:hover {
      background: rgba($primary-blue, 0.07);
      border: 1px dashed $primary-blue;
      > div::before {
        background: url(~@/assets/images/register/upload1_active.png);
        background-size: 100% 100%;
      }
    }
    .vue-pdf-embed {
      position: absolute;
      top: 0;
      opacity: 0;
      transition: all 0.3s;
    }
    .el-upload-dragger {
      width: 100%;
      height: 100%;
      border-radius: 20px;
      background-color: transparent;
      border: none;
    }
    .upload-add {
      margin: 12px;
    }
    .docx-area {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 0 50px;

      > img {
        position: inherit;
        width: 32px;
        margin-right: 10px;
        background: none;
      }
      span {
        width: calc(100% - 50px -45px);
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 使用省略号显示溢出文本 */
        text-align: center;
      }
    }
  }

  /deep/ .el-upload-list {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;

    .el-upload-list__item {
      border: none;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      margin-top: 0;
      .el-upload-list__item-thumbnail {
        background-color: transparent;
        width: auto;
        height: auto;
        max-height: 90px;
      }
      .el-upload-list__item-status-label {
        display: none;
      }
      .el-upload-list__item-name {
        display: none;
      }
      .el-icon-close {
        display: none;
      }
    }
  }
}
// no file
.pug-upload.no-file {
  .upload-container {
    /deep/ .el-upload-list {
      display: none;
    }
  }

  .upload-area {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3d3d3d;
    position: relative;

    &.pre-view {
      display: none;
    }
  }

  .actions {
    display: none;
  }
}

// pdf pre-viewer
.pdf-previewer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9999;
  .close-preview-btn {
    position: absolute;
    align-self: flex-end;
    cursor: pointer;
    z-index: 1000;
    top: 20px;
    right: 16px;
    width: 28px;
    height: 28px;
    font-size: 28px;
    > i {
      color: #fff;
      border-radius: 50%;
      background-color: #606266;
    }
  }

  .vue-pdf-embed > div {
    margin-bottom: 8px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
  }

  .app-button {
    padding: 16px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
    background-color: #555;
    color: #ddd;
    span {
      margin: 0 10px;
    }
  }

  .app-content {
    padding: 24px 16px;
    width: 600px;
  }

  .right {
    float: right;
  }
}

@media (max-width: 768px) {
  .pug-upload {
    width: 98%;
    height: 100px;
    &:first-child {
      margin-bottom: 20px;
    }
  }
  .pdf-previewer {
    .app-content {
      width: auto;
    }
  }
}
</style>
